'use client';
import React, { useState } from 'react'
import Burger from './burger'
import Menu from './menu'
import Stairs from './stairs'
import { motion, AnimatePresence } from 'framer-motion';
import Container from 'components/Container';

export default function Index({ titleClass = "" }: { titleClass: any }) {

    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <header className="relative z-50 flex w-full justify-center">
            {titleClass &&
                <Container className="absolute mt-4">
                    <motion.div className='w-fit'
                        onHoverStart={() => setIsHovered(true)}
                        onHoverEnd={() => setIsHovered(false)}
                    >
                        <a href="/" className="font-nebulica text-2xl flex w-fit">
                            <motion.div
                                initial={{ rotate: 0 }}
                                animate={isHovered ? { rotate: 360 } : { rotate: 0 }}
                                className="me-2"
                            >
                                ©
                            </motion.div>
                            Code by Surya
                        </a>
                        <div className="w-[80px] ml-auto mt-[1px] flex flex-row-reverse">
                            <motion.div initial={{ width: 0 }}
                                animate={isHovered ? { width: "100%" } : { width: 0 }}
                                className='block h-[2px] w-[80px] bg-smoke'></motion.div>
                        </div>
                    </motion.div>
                </Container>}
            <Burger openMenu={() => { setMenuIsOpen(true) }} />
            <AnimatePresence mode="wait">
                {
                    menuIsOpen && <>
                        <Stairs />
                        <Menu closeMenu={() => { setMenuIsOpen(false) }} />
                    </>
                }
            </AnimatePresence>
        </header >
    )
}